import { render, staticRenderFns } from "./Attachs.vue?vue&type=template&id=b7ac44e0&scoped=true"
import script from "./Attachs.vue?vue&type=script&lang=js"
export * from "./Attachs.vue?vue&type=script&lang=js"
import style0 from "./Attachs.vue?vue&type=style&index=0&id=b7ac44e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ac44e0",
  null
  
)

export default component.exports